var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error403"},[_c('Header',{attrs:{"isShowUser":false}}),_c('errorItem',{attrs:{"data":_vm.data,"noSHowDashboard":true}},[_c('img',{attrs:{"src":require("@/assets/images/403_03.jpg")}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }